'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import SVG, { SVGProps } from '../svg'

// SVGs
// @ts-ignore
import LogotypeSVG from './logotype.react.svg'

/* -----------------------------------------------------------------------------
 * Logotype
 * -------------------------------------------------------------------------- */

export type LogotypeProps = Omit<SVGProps, 'svg'>

function Logotype(props: LogotypeProps) {
  return <SVG svg={LogotypeSVG} width={94} height={24} fill='red' {...props} />
}

export default Logotype
